// Changes here should match the Themes/Environments and Themes/Constants

// Colors
export const primaryColorProduction: string = '#171482';
export const secondaryColorProduction: string = '#52bf24';
export const statsRedColor: string = '#dc3545';
export const chartStrokeColor: string = '#f0f0f0';
export const chartComparisonGray: string = '#98a6ad';
export const navyColor: string = '#024059';

export const sidebarWidthPx: number = 80;
export const pagePaddingPx: number = 16;

export const keytrak_black: string = '#262626';
export const keytrak_gold: string = '#B99C62';
export const keytrak_red: string = '#E82633';
export const keytrak_blue: string = '#427684';


export const checkin_green: string = '#386C0B';
export const pickup_purple: string = '#824C71';
export const mobile_blue: string = '#5AB1BB';
export const incomplete_yellow: string = '#CD8B08';
export const ro_bronze: string = '#B44F07';
export const towin_maroon: string = '#570000';